import {Button, MenuItem, Select} from '@material-ui/core';
import React, {useMemo, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-thin-svg-icons';
import {IGenericType} from 'constants/interfaces';

interface IButtonAddFeesProps {
  title: string;
  options: Array<IGenericType & any>;
  selectedOptions: Array<any>;
  onSelect: (option: any) => void;
}

const ButtonAddFees = ({
  title,
  options,
  selectedOptions,
  onSelect,
}: IButtonAddFeesProps) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const listOptions = useMemo(() => {
    return options.filter(
      (option) => !selectedOptions.map((o) => o?.id).includes(option?.id),
    );
  }, [options, selectedOptions]);
  const doSelect = (fee: any) => {
    onSelect(fee);
    setIsFlipped(false);
  };
  return (
    <div className={`flip-card-content ${isFlipped ? 'flipped' : ''}`}>
      <div className="flip-card-front">
        <Button
          variant="contained"
          color="primary"
          style={{minWidth: 185}}
          onClick={() => setIsFlipped(!isFlipped)}
        >
          {title}
        </Button>
      </div>
      <div className="flip-card-back row">
        <Select
          // value={value}
          // onChange={onChange}
          placeholder="Select service"
          fullWidth
          variant="outlined"
          style={{height: 40}}
        >
          {listOptions.map((option) => (
            <MenuItem
              key={option.id}
              value={option.id}
              onClick={() => doSelect(option)}
            >
              {option.name}
            </MenuItem>
          ))}
        </Select>
        <FontAwesomeIcon
          className="pointer"
          icon={faXmark}
          onClick={() => setIsFlipped(false)}
          style={{marginLeft: 10, fontSize: 25}}
        />
      </div>
    </div>
  );
};

export default ButtonAddFees;
